// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum EscalatorFault {
  Underspeed = 0,
  SafetyBreak = 1,
  PhaseFailure = 2,
  SmokeDetector = 3,
  KeySwitchStop = 4,
  ConsecutiveStop = 5,
  MotorUnderspeed = 6,
  ExternalShutdown = 7,
  SeismicMonitor = 8,
  Safety = 9,
  Generic = 10,
  CombplateTopLeft = 11,
  HandrailTopLeft = 12,
  SkirtingTop = 13,
  EmergencyStop = 14,
  CombplateBottomLeft = 15,
  HandrailBottomLeft = 16,
  ChaintensionBottom = 17,
  DriveChain = 18,
  HandrailDrop = 19,
  StepUpthrust = 20,
  CombHeating = 21,
  SkirtingBottom = 22,
  Direction = 23,
  BrokenStepBottom = 24,
  StopSwitchTop = 25,
  HandrailStretch = 26,
  StopSwitchBottom = 27,
  FrequencyConverter = 28,
  StopSwitchAuxiliary = 29,
  FloorCoverTop = 30,
  OverspeedTop = 31,
  UnderspeedTop = 32,
  HandrailMonitorLeft = 33,
  HandrailMonitorRight = 34,
  ServiceBrake = 35,
  EmergencyBrake = 36,
  BrokenStepTop = 37,
  SensorInmgb = 38,
  StepAbsenceTop = 39,
  SensorInvkTop = 40,
  StepAbsenceBottom = 41,
  SensorInvkBottom = 42,
  OverspeedBottom = 43,
  UnderspeedBottom = 44,
  SoftStop = 45,
  ParameterLost = 46,
  SreDrop = 47,
  HandrailTopRight = 48,
  HandrailBottomRight = 49,
  CombplateTopRight = 50,
  CombplateBottomRight = 51,
  SafetyCircuit = 52,
  FloorCoverBottom = 53,
  UndefinedStop = 54,
  ContinuousOperation = 55,
  ReadyToStart = 56,
  MotorOnMains = 57,
  AutomaticService = 58,
  EscalatorRunning = 59,
  Down = 60,
  Up = 61,
  TUVSimulation = 62,
  InspectionMode = 63,
  LightCurtainActive = 64,
  ResetMHardware = 65,
  ResetS0Hardware = 66,
  ResetS1Hardware = 67,
  ResetS2Hardware = 68,
  ResetS3Hardware = 69,
  ResetDHardware = 70,
  ResetMBussRetry = 71,
  ResetS0BussRetry = 72,
  ResetS1BussRetry = 73,
  ResetS2BussRetry = 74,
  ResetS3BussRetry = 75,
  ResetDBussRetry = 76,
  ResetMBufferFull = 77,
  ResetS0BufferFull = 78,
  ResetS1BufferFull = 79,
  ResetS2BufferFull = 80,
  ResetS3BufferFull = 81,
  ResetDBufferFull = 82,
  ResetMWrongMess = 83,
  ResetS0WrongMess = 84,
  ResetS1WrongMess = 85,
  ResetS2WrongMess = 86,
  ResetS3WrongMess = 87,
  ResetDWrongMess = 88,
  ResetMMaster = 89,
  ResetS0Master = 90,
  ResetS1Master = 91,
  ResetS2Master = 92,
  ResetS3Master = 93,
  ResetDMaster = 94,
  ResetMTimeOut = 95,
  ResetS0TimeOut = 96,
  ResetS1TimeOut = 97,
  ResetS2TimeOut = 98,
  ResetS3TimeOut = 99,
  ResetDTimeOut = 100,
  ResetMFcom = 101,
  ResetS0Fcom = 102,
  ResetS1Fcom = 103,
  ResetS2Fcom = 104,
  ResetS3Fcom = 105,
  ResetDFcom = 106,
  ResetMSlave = 107,
  VoltageOff = 108,
  SmokeDetectorBottom = 109,
  SkirtingMiddle = 110,
  PhaseControl = 111,
  RubberTop = 112,
  RubberBot = 113,
  BlockingDevice = 114,
  CombHeatingTop = 115,
  StepUpthrustBottom = 116,
  BrakeLining = 117,
  DeviceStopByCustomer = 118,
  DeviceWaterLevelBottom = 119,
  ContactorPickUp = 120,
  F0x00 = 121,
  F0x01 = 122,
  F0x02 = 123,
  F0x03 = 124,
  F0x04 = 125,
  F0x05 = 126,
  F0x06 = 127,
  F0x07 = 128,
  F0x08 = 129,
  F0x09 = 130,
  F0x0A = 131,
  F0x0B = 132,
  F0x0C = 133,
  F0x0D = 134,
  F0x0E = 135,
  F0x0F = 136,
  F0x18 = 137,
  F0x1C = 138,
  F0x20 = 139,
  F0x21 = 140,
  F0x22 = 141,
  F0x23 = 142,
  F0x27 = 143,
  F0x29 = 144,
  F0x37 = 145,
  F0x40 = 146,
  F0x42 = 147,
  F0x43 = 148,
  F0x46 = 149,
  F0x47 = 150,
  F0x5A = 151,
  F0x5B = 152,
  F0x5C = 153,
  F0x5D = 154,
  F0x5E = 155,
  F0x60 = 156,
  F0x61 = 157,
  F0x62 = 158,
  F0x63 = 159,
  F0x64 = 160,
  F0x65 = 161,
  F0x66 = 162,
  F0x67 = 163,
  F0x68 = 164,
  F0x69 = 165,
  F0x6A = 166,
  F0x6B = 167,
  F0x6C = 168,
  F0x6D = 169,
  F0x6E = 170,
  F0x6F = 171,
  F0x70 = 172,
  F0x71 = 173,
  F0x72 = 174,
  F0x73 = 175,
  F0x74 = 176,
  F0x75 = 177,
  F0x76 = 178,
  F0x77 = 179,
  F0x78 = 180,
  F0x79 = 181,
  F0x7A = 182,
  F0x7B = 183,
  F0x7C = 184,
  F0x7D = 185,
  F0x7E = 186,
  F0x7F = 187,
  F0x80 = 188,
  F0x81 = 189,
  F0x82 = 190,
  F0x83 = 191,
  F0x84 = 192,
  F0x85 = 193,
  F0x86 = 194,
  F0x87 = 195,
  F0x88 = 196,
  F0x89 = 197,
  F0x8A = 198,
  F0x8B = 199,
  F0x8C = 200,
  F0x8D = 201,
  F0x8E = 202,
  F0x8F = 203,
  F0x90 = 204,
  F0x91 = 205,
  F0x92 = 206,
  F0x93 = 207,
  F0x94 = 208,
  F0x95 = 209,
  F0x96 = 210,
  F0x97 = 211,
  F0x98 = 212,
  F0x99 = 213,
  F0x9A = 214,
  F0x9B = 215,
  F0x9C = 216,
  F0x9D = 217,
  F0x9E = 218,
  F0x9F = 219,
  F0xCC = 220,
  F0xCD = 221,
  F0xCE = 222,
  F0xCF = 223,
  F0xD0 = 224,
  F0xF0 = 225,
  F0xF1 = 226,
  F0xF2 = 227,
  F0xF3 = 228,
  F0xF4 = 229,
  F0xF5 = 230,
  F0xF6 = 231,
  F0xF7 = 232,
  F0xF8 = 233,
  F0xF9 = 234,
  F0xFA = 235,
  F0xFB = 236,
  F0xFC = 237,
  F0xFD = 238,
  F0xFE = 239,
  F0xFF = 240,
  OrderSpecific = 241,
  ContactorDropoutCheck = 242,
  HandRailEntryBottomRight = 243,
  HandRailEntryTopRight = 244,
  MissingStepTop = 245,
  MonitoringContactorTop = 246,
  Thermal = 247,
  F0xDC = 248,
  F0xDD = 249,
  F0xDE = 250,
  F0xDF = 251,
  MotorFailedToStop = 252,
  RedundantAccess = 253,
  RedundantCarBypass = 254,
  RedundantInsPmr = 255,
  BrakeIOFailedOff = 256,
  BrakeIOFailedOn = 257,
  CarComDeviceReset = 258,
  DonIoFailedOn = 259,
  DownDirectional = 260,
  DriveReady = 261,
  GsAndGs1Opposite = 262,
  HcComDeviceReset = 263,
  PInputOffFault = 264,
  PInputOnFault = 265,
  RunORunAFailed = 266,
  RunRunADNRFail = 267,
  RunRunAUpFail = 268,
  SafetyString = 269,
  DLBAndDLB1Opposite = 270,
  DLMAndDLM1Opposite = 271,
  DLTAndDLT1Opposite = 272,
  F0x13 = 273,
  F0x24 = 274,
  F0x4D = 275,
  F0x53 = 276,
  F0xE1 = 277,
  F0xE2 = 278,
  F0xE3 = 279,
  F0xE4 = 280,
  F0xE5 = 281,
  F0xE6 = 282,
  F0xE7 = 283,
  F0xE8 = 284,
  F0xE9 = 285,
  F0xEA = 286,
  F0xEB = 287,
  F0xEC = 288,
  F0xED = 289,
  F0xEE = 290,
  F0xEF = 291
}
